import type { ContextFamily } from '@quipex/shared/utils';
import type { QuippySuggestionCategory } from '../models';

export const CATEGORY_COLOR_CONTEXTS = {
    'Understand it': 'primary',
    'Keep it running': 'warning',
    'Manage risk': 'destructive',
    'Meet obligations': 'success',
    'Find evidence': 'info',
    'Coordinate people': 'caution',
    'Improve performance': 'success',
    'Assess value & use': 'info',
    'Plan change': 'primary',
} as const satisfies Record<QuippySuggestionCategory, ContextFamily>;
